<template>
  <span
    ref="nodeEl"
    :key="isUpdated"
    class="uk-flex uk-flex-wrap"
    @mouseup="$emit('mouseup', $event)"
    @mouseenter="$emit('hoverIn', nodeData, $event)"
    @mouseleave="$emit('hoverOut', nodeData, $event)"
    @click="$emit('click', nodeData, $event)"
  >
    <slot></slot>

    <span
      v-if="canAddCitations || hasCitations"
      class="outline-node-citations-icon uk-flex uk-flex-middle"
      :class="{
        'outline-node-citations-icon-new': !hasCitations,
        'outline-node-citations-icon-open': showingOutlineNodeCitationsMap[nodeData.nodeKey],
      }"
    >
      <div class="uk-flex uk-flex-column" @click.stop="doClickCitationsButton">
        <img
          :src="`/icons/black/icon-black${!hasCitations ? '-create' : previousCitation ? '-close' : '-open'}-citation.svg`"
          :style="{ height: hasCitations ? '24px' : '25px' }"
          :class="{ 'open-citation-style': !previousCitation }"
        />
      </div>
      <span
        v-if="showingOutlineNodeCitationsMap[nodeData.nodeKey]"
        class="outline-node-citations uk-background-muted"
      ></span>
    </span>

    <div
      v-if="hasCitations && showingOutlineNodeCitationsMap[nodeData.nodeKey]"
      class="outline-node-citations-box uk-flex uk-flex-column uk-width-1-1 uk-text-small uk-margin-top uk-background-muted uk-border-rounded uk-width-1-1 uk-padding-small uk-margin-remove"
      :class="{
        'outline-node-citations-show': showingOutlineNodeCitationsMap[nodeData.nodeKey],
      }"
    >
      <span class="uk-flex uk-flex-between outline-citaions-margin">
        <span style="color: black"> Citations: </span>
      </span>
      <div v-for="citation in nodeCitations" :key="citation._id">
        <CitationRow
          :citation="citation"
          :parent="nodeData"
          :parentCounterpoint="counterpointData.roundZero"
          :parentAuthor="documentData.createdBy"
          :outlineCitation="true"
        />
      </div>
      <div v-if="canAddCitations && hasCitations < 3">
        <span
          @click.prevent="doClickAddMoreCitationsButton"
          uk-tooltip="Add a new citation"
          style="margin-left: -2px"
        >
          <img
            class="uk-margin-small-top uk-margin-small-bottom"
            :src="`/icons/black/icon-black-create-citation.svg`"
            width="30"
            style="opacity: 0.5; height: 24px"
          />
        </span>
      </div>
    </div>
  </span>
</template>

<script>
import { EventBus } from '@/assets/js/event-bus';
import DocumentType from '@/assets/js/enum/DocumentType';
import CitationRow from '@/components/citations/CitationRow.vue';
import UIkit from 'uikit';
import { mapState } from 'vuex';

export default {
  name: 'OutlineNode',

  components: {
    CitationRow,
  },

  props: {
    nodeData: Object,
    canAddCitations: Boolean,
  },

  data() {
    return {
      isUpdated: 0,
      previousCitation: false,
    };
  },

  computed: {
    EventBus() {
      return EventBus;
    },
    DocumentType() {
      return DocumentType;
    },
    UIkit() {
      return UIkit;
    },

    ...mapState([
      'citations',
      'documentData',
      'counterpointData',
      'showingOutlineNodeCitationsMap',
    ]),

    nodeCitations() {
      return this.citations[this.nodeData.nodeKey];
    },
    hasCitations() {
      return this.nodeCitations && this.nodeCitations.length;
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$emit('updated');
    });
    this.showingOutlineNodeCitationsMap[this.nodeData.nodeKey] = false;
  },
  updated() {
    this.$emit('updated');
  },
  watch: {
    hasCitations(value) {
      if (value === 0) {
        this.showingOutlineNodeCitationsMap[this.nodeData.nodeKey] = false;
      }
    },
  },
  methods: {
    doClickCitationsButton() {
      if (this.hasCitations) {
        EventBus.emit('click.citation.show.outline');
        // toggle open/close citations box
        this.showingOutlineNodeCitationsMap[this.nodeData.nodeKey] =
          !this.showingOutlineNodeCitationsMap[this.nodeData.nodeKey];
        this.isUpdated++;
        this.previousCitation = !this.previousCitation;
      } else
        // open new citation modal
        EventBus.emit('citation.new', this.nodeData, DocumentType.OUTLINE);
    },

    doClickAddMoreCitationsButton() {
      // open new citation modal
      EventBus.emit('citation.new', this.nodeData, DocumentType.OUTLINE);
    },

    doClickCitationLink(citation, nodeData) {
      const citationEvent = this.canAddCitations ? 'citation.edit' : 'citation.review';
      EventBus.emit(citationEvent, citation, nodeData, 'outline');
    },

    removeCitationClicked(citation, nodeData) {
      EventBus.emit('citation.remove', citation, nodeData, 'outline');
    },
  },
};
</script>

<style lang="sass" scoped>
.show
  display: block
.citation-margin
  margin-left: 25px
.outline-citaions-margin
  margin-bottom: 10px !important
.open-citation-style
  margin-top: 3px
</style>
